import TextAreaInput from './TextAreaInput';
export default TextAreaInput;
